if (!customElements.get('product-testimonial-slider')) {
  class ProductTestimonialSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('DOMContentLoaded', () => {
        let carousel = this.querySelector('swiper-carousel')?.slider;
        if (!carousel) return;
        
        window.addEventListener('resize', debounce(() => {
          carousel = this.querySelector('swiper-carousel')?.slider;
          carousel.on('slideChange', e => {
            this.querySelector('[data-action="scroll-to"][data-index].active')?.classList.remove('active');
            this.querySelector(`[data-action="scroll-to"][data-index="${e.activeIndex}"]`)?.classList.add('active');
          });
        }), 1000);
        
        this.addEventListener('click', (e) => {
          const button = e.target.closest('[data-action="scroll-to"][data-index]');
          if(!button) return;
          
          carousel.slideTo(Number(button.dataset.index));
          
          this.querySelector('[data-action="scroll-to"][data-index].active')?.classList.remove('active');
          button.classList.add('active');
        });
        
        carousel.on('slideChange', e => {
          this.querySelector('[data-action="scroll-to"][data-index].active')?.classList.remove('active');
          this.querySelector(`[data-action="scroll-to"][data-index="${e.activeIndex}"]`)?.classList.add('active');
        });
        
      });
    }
  }
  customElements.define('product-testimonial-slider', ProductTestimonialSlider);
}